import { Controller } from "@hotwired/stimulus"

// 사이드바에서 현재 활성 메뉴로 자동 스크롤하는 컨트롤러
export default class extends Controller {
  connect() {
    // DOM이 완전히 렌더링된 후 스크롤 실행
    requestAnimationFrame(() => {
      this.scrollToActiveMenu()
    })
  }

  scrollToActiveMenu() {
    const activeLink = this.element.querySelector('.sidebar-link.active')

    if (activeLink) {
      // 네비게이션 컨테이너 (스크롤 가능한 영역)
      const scrollContainer = this.element.querySelector('nav.overflow-y-auto')

      if (scrollContainer) {
        // 활성 메뉴가 보이도록 스크롤 (즉시 실행)
        activeLink.scrollIntoView({
          behavior: 'instant',
          block: 'center'
        })
      }
    }
  }
}
